import Validator from '../validator';

const CacncelRequestValidator = new Validator([
  {
    field: 'description',
    method: 'isEmpty',
    validWhen: false,
    message: 'Description of your Request cannot be empty.',
  },
  {
    field: 'file',
    method: 'isEmpty',
    validWhen: false,
    message: 'A signed Cancellation/ERP document must be attached.',
  },
]);

export default CacncelRequestValidator;
